/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints" DataTable endpoint.
 * Fetches paginated constraints (Conman guardrails) and transforms the response
 * from Conman's pagination format into the standard DataTable format ({ hits, results }).
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraints } from "./constants";
import type {
  ConmanConstraintsResponse,
  DecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraints = reactQueryTableFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraints,
  async (
    signal: AbortSignal,
    { appGroupId, dsaId, limit = 10, start = 0 }: DecisioningStudioAgentsAppGroupIdDsaIdConstraintsParams
  ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult> => {
    const rawResponse = await fetch<ConmanConstraintsResponse>(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints`,
      "GET",
      { limit, start },
      { signal },
      { propagateFetchRequestError: false }
    );

    return {
      hits: rawResponse.meta.pagination.total ?? 0,
      results: rawResponse.data,
    };
  },
  isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraintsResult
);
